import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "./Layout";
import HomeIcon from "../assets/icons/home_icon";
import config from "../config";
import { Pagination } from '@mui/material';
import { toast } from "react-toastify";



import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // British format

registerLocale("en-GB", enGB);


const QuotePage = () => {
  const [quotes, setQuotes] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [oneMonthBefore, setOneMonthBefore] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const navigate = useNavigate();
  const [selectedOrderBy, setSelectedOrderBy] = useState("quoteDate");
  const [selectedFilter, setSelectedFilter] = useState("");


  const [page, setPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);


  useEffect(() => {
  const fetchQuotes = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/v1/quotesList`, {
        params: {
          status: activeTab === "All" ? "" : activeTab,
          order_by: selectedFilter,
          filter_by: selectedFilter,
          page,
          limit: 10,
        },
      });
      
      // Adjust based on your backend response shape
      setQuotes(response.data.quotes);
      setTotalPages(response.data.totalPages); // Make sure your API returns this
    } catch (error) {
      console.error("Error fetching quotes:", error);
    }
  };

  fetchQuotes();
}, [activeTab, selectedOrderBy, selectedFilter, page]);


  const getFilteredQuotes = () => {
    if (activeTab === "All") return quotes;
    return quotes.filter((quote) => quote.status === activeTab);
  };

  const handleRowClick = (quoteNo) => {
    navigate(`/edit-quote/` + quoteNo);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear().toString().slice(-4);
    return `${day}/${month}/${year}`;
  };


  const parseDate = (dateStr) => {
  const parsed = new Date(dateStr);
  return isNaN(parsed) ? null : parsed;
};


  useEffect(() => {
    const today = new Date();
    const oneMonthAgo = new Date(new Date().setMonth(today.getMonth() - 1));

    setCurrentDate(today.toISOString().split("T")[0]);
    setOneMonthBefore(oneMonthAgo.toISOString().split("T")[0]);
  }, []);

  const handleDateChange = (e, type) => {
    const selectedDate = e.target.value;
    if (type === "start") {
      setOneMonthBefore(selectedDate);
    } else if (type === "end") {
      setCurrentDate(selectedDate);
    }
  };
  const handleFilterChange = (e) => {
    const selectedOption = e.target.value;
    if (selectedOption === "") {
      setSelectedFilter("");
    } else {
      switch (selectedOption) {
        case "quoteDate":
          setSelectedFilter("quoteDate");
          break;
        case "weddingDate":
          setSelectedFilter("weddingDate");
          break;
        case "deliveryDate":
          setSelectedFilter("deliveryDate");
          break;
        default:
          setSelectedFilter("");
          break;
      }
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateType, setSelectedDateType] = useState("Order Date");

  const handleExportCSV = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({
        start_date: oneMonthBefore,
        end_date: currentDate,
        date_type: selectedOrderBy
      }).toString();

      const response = await fetch(`${config.BASE_URL}/api/v1/export-quote-csv?${params}`);
      if (!response.ok) {
        throw new Error("No quotes found for the selected date range");
      }

  

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "quotes.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Failed to export CSV. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDateTypeChange = (e) => {
    setSelectedDateType(e.target.value);
  };

  return (
    <Layout>
      <div className="quote-page">
        <header className="header">
          <h1>ALL QUOTES</h1>
          <p>
            <Link to="/" className="home-link">
              <HomeIcon />
            </Link>{" "}
            / Customers / All Quotes
          </p>
        </header>

        <div className="page_card_body">
          <div className="quote_tabs_outer">
            {["All", "Pending", "Accepted"].map((tab) => (
              <button
                key={tab}
                className={`btn ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab} Quotes
              </button>
            ))}
          </div>

          <div className="quotes_tabs_content">
            <div className="filters">
              <div className="export-section">
                <span className="export_sectionfieldset_label">EXPORT CSV</span>
                <select
                  id="orderBy"
                  name="order_by"
                  className="dropdown"
                  value={selectedOrderBy}
                  onChange={(e) => setSelectedOrderBy(e.target.value)}
                >
                  <option value="quoteDate"> Quote Date </option>
                  <option value="weddingDate"> Wedding Date </option>
                  <option value="deliveryDate"> Delivery Date </option>
                </select>


                <ReactDatePicker
                className="date-picker"
                selected={oneMonthBefore ? new Date(oneMonthBefore) : null}
                onChange={(date) => {
                  if (date) {
                    setOneMonthBefore(date.toISOString().split("T")[0]);
                  }
                }}
                dateFormat="dd/MM/yyyy"
                locale="en-GB"
                placeholderText="Start Date"
              />

              <ReactDatePicker
                className="date-picker"
                selected={currentDate ? new Date(currentDate) : null}
                onChange={(date) => {
                  if (date) {
                    setCurrentDate(date.toISOString().split("T")[0]);
                  }
                }}
                dateFormat="dd/MM/yyyy"
                locale="en-GB"
                placeholderText="End Date"
              />



                
                <button className="export-btn" onClick={handleExportCSV}>Export to CSV</button>
                {isLoading && (
                  <div className="spinner">
                    <div className="rect1"></div>
                    <div className="rect2"></div>
                    <div className="rect3"></div>
                    <div className="rect4"></div>
                  </div>
                )}

              </div>
              <div className="filter-dropdowns">
                <h5>Filter by</h5>
                <select
                  className="dropdown"
                  onChange={handleFilterChange}
                  value={selectedFilter}
                >
                  <option value="">Select Filter</option>
                  <option value="quoteDate">Quote Date</option>
                  <option value="weddingDate">Wedding Date</option>
                  <option value="deliveryDate">Delivery Date</option>
                </select>
              </div>
            </div>

            <div className="table_outer_for_scroll">
              <table className="quote-table common_table">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Quote No</th>
                    <th>Quote Date</th>
                    <th>Delivery Date</th>
                    <th>Wedding Date</th>
                    <th>Total Price</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {getFilteredQuotes()?.map((quote, index) => (
                    <tr
                      key={index}
                      onClick={() => handleRowClick(quote._id)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{quote.customer_id?.customer_name}</td>
                      <td>{quote.quoteNo}</td>
                      <td>{formatDate(quote.quoteDate)}</td>
                      <td>{formatDate(quote.deliveryDate)}</td>
                      <td>{formatDate(quote.weddingDate)}</td>
                      <td>{quote.totalPrice}</td>
                      <td>{quote.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
  <Pagination
  variant="outlined" shape="rounded"
    count={totalPages}
    page={page}
    onChange={(event, value) => setPage(value)}
    color="primary"
   
  />
</div>



    </Layout>
  );
};

export default QuotePage;
